export default __webpack_public_path__ + "static/media/icon--20-world.7675618e.svg";